<template>
  <animation-layout :cclink="this.$store.state.cclink + 'SHOWCASE'">
    <div :style="`background-color:#${bgcolor};color:#${fgcolor};font-weight:500;font-size:53px;text-align:center;padding:28px`" v-html="item.title"></div>
    <div style="text-align:center;padding:0 35px 35px 35px">
      <showcase-panel v-for="(artist,index) in item.artists" :key="artist.portfolio_url" :artist="artist" :showArtist="item.show_artists"
        :last="index === item.artists.length -1" :animation="true" :colors="item" />
    </div>
    <div style="background-color:#E7E2DB;text-align:center;padding:35px;font-size:18px;line-height:32px;margin-bottom:35px" v-show="item.gal_title">
      <h3 style="color:#ce0e2d;font-size:48px;font-weight:normal">{{ item.gal_title }}</h3>
      <a :href="'https://www.illustrationx.com' + item.gal_link + this.$store.state.cclink + 'SHOWCASE'" target="_blank">
        <img :src="'https://media.illustrationx.com/' + item.gal_image" v-show="item.gal_image" style="max-width:100%;margin-top:20px;">
      </a>
      {{ item.gal_text }}
      <div style="margin:20px">
        <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="'https://www.illustrationx.com' + item.gal_link + this.$store.state.cclink + 'SHOWCASE'" target="_blank">visit the gallery</a>
      </div>
    </div>
    <div style="background-color:ffffff;text-align:center;padding:35px;font-size:18px;line-height:32px;margin-bottom:35px" v-show="item.news_title">
      <h3  style="color:#ce0e2d;font-size:48px;font-weight:normal">{{ item.news_title }}</h3>
      <a :href="'https://www.illustrationx.com/' + item.news_link + this.$store.state.cclink + 'SHOWCASE'" target="_blank">
        <img :src="'https://media.illustrationx.com/' + item.news_image" v-show="item.news_image" style="max-width:100%;margin-top:20px;">
      </a>
      {{ item.intro }}
      <div style="margin-top:20px">
        <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="'https://www.illustrationx.com/' + item.news_link + this.$store.state.cclink + 'SHOWCASE'" target="_blank">read more</a>
      </div>
    </div>
  </animation-layout>
</template>

<script>
import ShowcasePanel from '../components/ShowcasePanel.vue'
import NewTalentLoader from '../mixins/NewTalentLoader'
import AnimationLayout from '../layouts/AnimationLayout.vue'

export default {
  components: {
    ShowcasePanel,
    AnimationLayout
  },
  mixins: [NewTalentLoader],
  computed:{
    fgcolor() {
      if(this.item.fgcolor) {
        return this.item.fgcolor
      }
      return 'FFFFFF'
    },
    bgcolor() {
      if(this.item.bgcolor) {
        return this.item.bgcolor
      }
      return '8B6F4B'
    }
  }
  

}
</script>

<style>
b {
  font-size:23px;
}
</style>